






































import {
    Component,
    Vue
} from 'vue-property-decorator';
import TenantClass from '@/views/tenants/TenantClass';
import TenantForm from '@/views/tenants/components/TenantForm';
import TenantStats from '@/views/tenants/components/TenantStats';
import UsersTableBody from '@/views/users/components/UsersTableBody.ts.vue';
import {
    namespace
} from 'vuex-class';

const Tenants = namespace('tenants');

@Component({
    components: {
        TenantForm,
        TenantStats
    }
})
export default class TenantView extends Vue {
    private tenantData: TenantClass = new TenantClass();

    get activeUserInfo () {
      return  JSON.parse(JSON.stringify(this.$store.state.auth.me.user))
    }

    private tenantUsers: ServerList = {};
    private tableBody: unknown = {
        component: UsersTableBody,
        bindings: {
            hoverFlat: true
        }
    }
    @Tenants.Action('getTenantUsers')
    private getTenantUsers!: ({
            id,
            params
        }: ({
            id: String,
            params ? : QueryParams
        })) => Promise < ServerList >

        async filter(params ? : QueryParams) {
            this.tenantUsers = await this.getTenantUsers({
                id: this.$route.params.id,
                params
            });
        }

    private created() {
        this.$store
            .dispatch('visitManagement/fetchTenant', this.$route.params.id)
            .then((data: TenantClass) => {
                this.tenantData = new TenantClass(data);
            });
    }

    private loginAsTenant() {
        this.$store
            .dispatch('visitManagement/setTenant', this.$route.params.id)
            .then((data: TenantClass) => {
               console.log('setTenant', data);
               this.$router.push('/dashboard')
               //location.reload();
            });
    }
}
